import { Box } from '@chakra-ui/react';

export default function Laptop(props) {
  return (
    <Box {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.6667 15.4167C17.5833 15.4167 18.325 14.6667 18.325 13.7501L18.3333 4.58341C18.3333 3.66675 17.5833 2.91675 16.6667 2.91675H3.33333C2.41667 2.91675 1.66667 3.66675 1.66667 4.58341V13.7501C1.66667 14.6667 2.41667 15.4167 3.33333 15.4167H0C0 16.3334 0.75 17.0834 1.66667 17.0834H18.3333C19.25 17.0834 20 16.3334 20 15.4167H16.6667ZM4.16667 4.58346H15.8333C16.2917 4.58346 16.6667 4.95846 16.6667 5.41679V12.9168C16.6667 13.3751 16.2917 13.7501 15.8333 13.7501H4.16667C3.70833 13.7501 3.33333 13.3751 3.33333 12.9168V5.41679C3.33333 4.95846 3.70833 4.58346 4.16667 4.58346ZM9.16667 15.4168C9.16667 15.8751 9.54167 16.2501 10 16.2501C10.4583 16.2501 10.8333 15.8751 10.8333 15.4168C10.8333 14.9585 10.4583 14.5835 10 14.5835C9.54167 14.5835 9.16667 14.9585 9.16667 15.4168Z"
          fill="currentColor"
        />
      </svg>
    </Box>
  );
}
